export default __webpack_public_path__ + "static/video-3-b70b72bb808ed60c6e9b46768365e324.png";